<template>
    <div>
        <b-modal
            id="addBundleModal"
            ref="addBundleModal"
            :lazy="true"
            :title="title"
            title-tag="h2"
            no-close-on-backdrop
        >
            <div v-if="warningMessagePayment">
                <div class="alert-wrapper pl-2">
                    <div
                        class="alert alert-warning alert-dismissible"
                        role="alert"
                    >
                        {{ warningMessagePayment }}
                    </div>
                </div>
            </div>
            <transition name="slide-fade">
                <add-bundle
                    ref="newBundle"
                    v-if="page == 'newBundle'"
                    :data="addBundle_data"
                    :isInvoice="isInvoice"
                    :invoiceId="invoiceDetails ? invoiceDetails.id : null"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class="pl-2"
                />
                <bundle
                    ref="bundle"
                    v-if="page == 'bundle'"
                    :data="bundle_data"
                    :app-data="addBundle_data"
                    :isEstimate="!isInvoice"
                    :totalInvoice="invoiceDetails.total_amount"
                    @loading="loading = true"
                    @loaded="loading = false"
                    @prevent-save="preventSave"
                    class="px-1"
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-btn
                    @click="$refs.addBundleModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-btn
                >
                <div v-if="loading" class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                </div>
                <div v-else class="float-right">
                    <b-btn
                        @click="back"
                        v-if="page != 'newBundle'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="save"
                        v-if="page == 'bundle'"
                        :disabled="
                            (page == 'bundle' &&
                                bundle_data.selectedElements.length === 0) ||
                            disableButtonSave ||
                            isHasUsersChooseInvoice
                        "
                        variant="primary"
                        >Save</b-btn
                    >
                    <b-btn @click="next" v-else variant="primary">Next</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
/**
 * @name AddBundle
 * @description new bundle modal
 * @see apps/assets/js/module/billing/item.js
 * @see apps/application/controllers/billing/procedure.php
 * @see apps/application/views/staff/billing/invoice/bundle/wizard.php
 * @see apps/application/views/staff/billing/invoice/bundle/create_update.php
 */

import { forEach, find } from "lodash";
import AddBundle from "./add-bundle.vue";
import Bundle from "@/module/commons/bundle/bundle";
import CONSTANTS from "@/constants/history";
import InvoiceItemServices from "@/services/invoice/invoice-item";
import EstimateItemServices from "@/services/estimate/estimate-item";
import PatientService from "@/services/patient";
import INVOICEITEM from "@/constants/invoice-item";
import LabMixin from "@/mixins/lab";

export default {
    components: {
        AddBundle,
        Bundle
    },
    mixins: [LabMixin],
    data() {
        return {
            page: "newBundle",
            loading: false,
            addBundle_data: {
                patient: null,
                bundle_id: [],
                staff_id: null,
                soap: -1,
                startDate: null,
                record_option: 0,
                datePickerOptions: {
                    format: "DD/MM/YYYY"
                },
                isDefaultProvider: false,
                defaultPatientId: null
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            title: "New Bundle",
            disableButtonSave: false
        };
    },
    props: {
        isInvoice: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        invoiceDetails() {
            return this.$store.getters["billing/invoiceDetails"];
        },
        estimateDetails() {
            return this.$store.getters["billing/estimateDetails"];
        },
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.invoiceDetails
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.invoiceDetails.id
                  )
                : "";
        }
    },
    watch: {},
    created() {
        let self = this;
        this.$on("change-page", page => {
            self.page = page;
        });
    },
    methods: {
        open() {
            this.addBundle_data.datePickerOptions.format = this.getDateFormat();
            if (this.isInvoice) {
                this.addBundle_data.client_id = this.invoiceDetails.client_id;
            } else {
                this.addBundle_data.client_id = !this.checkNullCharsUnicode(
                    this.estimateDetails.client_id
                )
                    ? this.estimateDetails.client_id
                    : null;
                this.addBundle_data.defaultPatientId = !this.checkNullCharsUnicode(
                    this.estimateDetails.default_patient_id
                )
                    ? this.estimateDetails.default_patient_id
                    : null;

                this.addBundle_data.staff_id = !this.checkNullCharsUnicode(
                    this.estimateDetails.default_provider_id
                )
                    ? this.estimateDetails.default_provider_id
                    : null;
            }
            this.page = "newBundle";
            this.$refs.addBundleModal.show();
        },
        preventSave(disable) {
            this.disableButtonSave = disable;
        },
        async save() {
            let self = this;
            let promise = true;
            let response = false;
            let bundleIds = [];

            if (self.page == "newBundle") {
                promise = await self.$refs.newBundle.$validator.validateAll();
            }
            if (self.page == "bundle") {
                promise = await self.$refs.bundle.$validator.validateAll();
            }

            if (promise) {
                self.loading = true;

                if (self.addBundle_data.bundle_id) {
                    forEach(self.addBundle_data.bundle_id, function (data) {
                        bundleIds.push(data.id);
                    });
                }
                const now = this._now();
                const currentDateUnix = this._fromDateStrToDateTime(
                    self.addBundle_data.startDate,
                    false
                )
                    .set({ hour: now.hour, minute: now.minute })
                    .toSeconds();

                let post = {
                    invoice_id: this.isInvoice ? self.invoiceDetails.id : null,
                    estimate_id: !this.isInvoice
                        ? self.estimateDetails.id
                        : null,
                    patient_id: this.addBundle_data.patient
                        ? self.addBundle_data.patient.id
                        : null,
                    soap_id:
                        self.addBundle_data.soap !== -1
                            ? self.addBundle_data.soap
                            : "",
                    provider_id: self.addBundle_data.staff_id
                        ? self.addBundle_data.staff_id
                        : null,
                    record_option: Number(self.addBundle_data.record_option),
                    templates: bundleIds,
                    start: currentDateUnix
                };
                // save bundle process
                if (self.bundle_data.selectedElements) {
                    post["items"] = [];
                    self.bundle_data.selectedElements.forEach(item => {
                        let detailItem = {};
                        detailItem["id"] = item.id;
                        detailItem["min_qty"] = item.quantity;
                        if (item.max_quantity)
                            detailItem["max_qty"] = item.max_quantity;
                        if (item.send_to_lab_value) {
                            detailItem["send_to_lab"] = Number(
                                item.send_to_lab_value
                            );
                        }
                        if (item.tag_number) {
                            detailItem["tag_number"] = item.tag_number;
                        }
                        post["items"].push(detailItem);
                    });
                }

                let response = this.isInvoice
                    ? await InvoiceItemServices.addBundle(post)
                    : await EstimateItemServices.addBundle(post);

                if (response && response.code == 200) {
                    self.loading = false;
                    self._message(response.message);

                    if (response.response.action_response) {
                        self.handleActionResponse(
                            response.response,
                            (message, variant) => {
                                self._message(message, variant);
                            }
                        );
                    }

                    self.$refs.addBundleModal.hide();
                    this.$emit("reload", CONSTANTS.VIEWS.RECORDS);

                    // if response return accession_id & antech_token,
                    // this indicate antech lab item is added hence display immersed ui iframe
                    if (
                        this.isInvoice &&
                        response.response &&
                        response.response.accession_id &&
                        response.response.antech_token
                    ) {
                        self.$root.$emit("call-antech-iframe", {
                            antech_token: response.response.antech_token,
                            accession_id: response.response.accession_id
                        });
                    }
                } else {
                    self.loading = false;
                    self._message(
                        response.message || "Bundle save error",
                        "danger"
                    );
                    if (response.code == 404) {
                        self.$nextTick(() => {
                            self.$refs.addBundleModal.hide();
                            // incase of deleted invoice, redirect to billing dashboard
                            if (
                                response.error_code ==
                                INVOICEITEM.ERROR_MESSAGE.INVOICE_DELETED
                            ) {
                                self.$emit("redirect-to-dashboard");
                            }
                        });
                    }
                }
            } else {
                self.loading = false;
            }
            return response;
        },
        async next() {
            let self = this;
            let promise = true;

            if (self.page == "newBundle") {
                if (self.page == "newBundle") {
                    promise = await self.$refs.newBundle.$validator.validateAll();
                }

                if (promise) {
                    if (this.addBundle_data.patient)
                        await this.getLatestVital();
                    self.$refs.newBundle.$validator
                        .validateAll()
                        .then(result => {
                            if (result) {
                                self.bundle_data.bundle_id =
                                    self.addBundle_data.bundle_id;

                                self.page = "bundle";
                                $(".modal-content").removeAttr("tabindex");
                            }
                        });
                }
            }
        },
        async getLatestVital() {
            this.addBundle_data.weight = null;
            this.addBundle_data.uom = null;
            if (!this.addBundle_data.patient) return;

            const res = await PatientService.getLatestVital(
                this.addBundle_data.patient.id
            );

            if (
                res &&
                Array.isArray(res.resources) &&
                res.resources.length > 0
            ) {
                let weight = find(res.resources, { master_vital_id: 4 });
                if (weight) {
                    this.addBundle_data.weight = weight.value;
                    this.addBundle_data.uom = weight.master_uom_id;
                }
            }
            return;
        },
        back() {
            if (this.page == "bundle") {
                this.page = "newBundle";
            }
        }
    }
};
</script>
